module.exports = __webpack_public_path__ + "media/images/card-visa-1d451f83a2308038cde0bd83099340e1.svg";